<template>
  <v-row justify="end">
    <SnackBar ref="snackbar" />
    <v-dialog v-model="dialog" width="680">
      <template #activator="{ props }">
        <v-btn
          color="#004984"
          v-bind="props"
          class="button-config"
          style="color: white"
        >
          Cadastrar Projeto
          <v-icon right style="margin-left: 5px">mdi-plus</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">Cadastrar Projeto</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="9">
                <v-text-field
                  v-model="nome"
                  variant="underlined"
                  label="Nome do projeto*"
                  required
                  :rules="[validateNome]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="8" md="3">
                <v-text-field
                  v-model="sigla"
                  variant="underlined"
                  label="Sigla*"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="equipeSelecionada"
                  variant="underlined"
                  :items="nomesEquipes"
                  label="Equipe*"
                  item-value="id"
                  item-text="nome"
                  required
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="descricao"
                  variant="underlined"
                  label="Descrição*"
                  required
                  no-resize
                  rows="2"
                  :maxlength="255"
                  @input="comentarioTamanho"
                  style="display: inline-block; width: 95%"
                ></v-textarea>
                <p style="display: inline-block; width: 5%; font-size: 10px">
                  {{ tamCom }}
                </p>
              </v-col>
            </v-row>
          </v-container>
          <small>*Campos Obrigatórios</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" variant="text" @click="dialog = false">
            Cancelar
          </v-btn>
          <v-btn color="blue-darken-1" variant="text" @click="registerProject">
            Cadastrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import axios from 'axios';

import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  data: () => ({
    dialog: false,
    nome: null,
    sigla: null,
    descricao: null,
    equipeSelecionada: null,
    equipes: [],
    nomesEquipes: [],
    tamCom: 255,
  }),
  components: {
    SnackBar,
  },
  created() {
    this.fetchEquipes();
  },
  methods: {
    /**
     * Registra um novo projeto no sistema.
     *
     * @function registerProject
     * @memberof ModalCadastrarProjeto
     * @param {void}
     * @returns {void}
     */
    registerProject() {
      const equipeSelecionada = this.equipeSelecionada;
      const equipe = this.equipes.find((e) => e.nome === equipeSelecionada);
      const data = {
        nome: this.nome,
        sigla: this.sigla,
        descricao: this.descricao,
        flencerrado: false,
        id_label: null, // eslint-disable-line
        id_equipe_fk: equipe.id, // eslint-disable-line
      };

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${store.state.token}`,
        },
      };

      axios
        .post(API_URL + '/projetos/', data, config)
        .then((response) => {
          console.log(response.data);
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Projeto ' + this.nome + ' cadastrado com sucesso!',
          );
          location.reload();
        })
        .catch((error) => {
          console.error(error);
        });

      // Emitir evento informando que o projeto foi criado com sucesso
      // this.$emit('projectCreated');

      // Limpar campos do formulário após cadastrar e fechar modal
    },
    /**
     * Faz uma requisição HTTP para buscar as equipes cadastradas no sistema.
     * @function fetchEquipes
     * @returns {void}
     */
    fetchEquipes() {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${store.state.token}`,
        },
      };

      axios
        .get(API_URL + '/equipes', config)
        .then((response) => {
          this.equipes = response.data.map((equipe) => ({
            id: equipe.id_equipe,
            nome: equipe.nome_equipe,
          }));
          console.log(this.equipes);
          this.nomesEquipes = this.equipes.map((equipe) => equipe.nome);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    comentarioTamanho() {
      this.tamCom = 255 - this.descricao.length;
    },
    validateNome(value) {
      // Use uma expressão regular para verificar se há apenas letras (sem números)
      const regex =
        /^(?=.*[A-Za-z\s])[\w\s!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~çÇáéíóúÁÉÍÓÚâêîôÂÊÎÔãõÃÕ]+$/u;
      if (!regex.test(value)) {
        return 'O texto inserido contém caracteres inválidos.';
      }

      return true;
    },
  },
};
</script>
<style scoped>
.button-config {
  background-color: #004984;
  text-transform: capitalize;
}
</style>
